<template>
  <aside
    class="ps hidden md:block"
    :class="{ 'ps--mini': !open, 'ps--peek': peek, 'ps--x': expanded }"
    @mouseenter="onEnter"
    @mouseleave="onLeave"
  >
    <div class="ps-card">
      <div class="ps-brand">
        <SidebarMarka :acik="expanded" />
      </div>
      <nav
        ref="navEl"
        class="ps-nav"
        :class="{ 'ps-intro': intro }"
        @mouseover="onHover"
        @mouseleave="hov.show = false"
        @mousemove="onSpot"
      >
        <span
          class="ps-ind"
          :class="{ on: ind.show }"
          :style="{ transform: `translateY(${ind.y}px)`, height: ind.h + 'px' }"
        ></span>
        <span
          class="ps-hov"
          :class="{ on: hov.show }"
          :style="{ transform: `translateY(${hov.y}px)`, height: hov.h + 'px' }"
        ></span>
        <div v-for="g in groups" :key="g.key" class="ps-grp">
          <div class="ps-sec" :style="{ '--i': idx[g.key] }">
            <span>{{ secTitle(g.key) }}</span>
          </div>
          <router-link
            v-for="item in g.items"
            :key="item.name"
            :to="item.path"
            class="ps-it"
            :class="{ on: isActive(item) }"
            :style="{ '--i': idx[item.name] }"
            :title="expanded ? undefined : $t(`navigation.${item.name}`)"
          >
            <span class="ps-ic"><svg viewBox="0 0 24 24" v-html="ICONS[item.name] || ICONS.dashboard"></svg></span>
            <span class="ps-lb">{{ $t(`navigation.${item.name}`) }}</span>
            <span v-if="item.name === 'esf' && review > 0" class="ps-bd">{{
              review > 999 ? '999+' : review
            }}</span>
          </router-link>
        </div>
      </nav>
      <div class="ps-theme" style="flex:none;margin:8px 0 0">
        <ThemeToggle :mini="!expanded" />
      </div>
      <div v-if="currentOrganization?.name || isSuper" class="ps-foot">
        <Teleport to="body">
          <transition name="pso">
            <div
              v-if="showSel"
              ref="popEl"
              class="pso"
              :style="popPos"
              role="dialog"
              aria-label="Выбор организации"
              @keydown="onPopKey"
            >
              <div class="pso-hd">
                <span class="pso-t">Организации</span>
                <span class="pso-n">{{ orgList.length }}</span>
              </div>
              <label class="pso-q">
                <svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="6.5" /><path d="M20 20l-4.2-4.2" /></svg>
                <input
                  ref="qEl"
                  v-model="orgQ"
                  type="text"
                  placeholder="Название или ИНН"
                  autocomplete="off"
                  spellcheck="false"
                />
              </label>
              <ul ref="listEl" class="pso-ls" role="listbox">
                <li
                  v-for="(o, i) in orgFiltered"
                  :key="o.id"
                  role="option"
                  :aria-selected="o.id === curId"
                  class="pso-it"
                  :class="{ on: o.id === curId, hl: i === orgHl, busy: switching === o.id }"
                  :style="{ '--i': i }"
                  @mouseenter="orgHl = i"
                  @click="pickOrg(o)"
                >
                  <span class="pso-m"><i>{{ o.mono }}</i></span>
                  <span class="pso-tx">
                    <span class="pso-nm">{{ o.clean }}</span>
                    <span class="pso-in"><b>ИНН</b>{{ o.inn || '—' }}</span>
                  </span>
                  <span v-if="switching === o.id" class="pso-sp"></span>
                  <svg v-else-if="o.id === curId" class="pso-ok" viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7.5" /></svg>
                </li>
                <li v-if="!orgFiltered.length" class="pso-empty">Ничего не найдено. Проверьте название или ИНН.</li>
              </ul>
            </div>
          </transition>
        </Teleport>
        <div
          ref="orgEl"
          class="ps-org"
          :class="{ 'ps-org--btn': isSuper }"
          :tabindex="isSuper ? 0 : undefined"
          :role="isSuper ? 'button' : undefined"
          :aria-expanded="isSuper ? showSel : undefined"
          @click="onOrgClick"
          @keydown.enter.prevent="onOrgClick"
        >
          <span class="ps-om"><i>{{ orgMono }}</i></span>
          <span class="ps-ot">
            <span class="ps-on">{{ orgName || $t('organizations.chooseOrganization') }}</span>
            <span v-if="currentOrganization?.inn" class="ps-oi" @click.stop>
              <span class="ps-oi-l">ИНН</span>
              <copy-btn>
                <span class="font-mono">{{ currentOrganization.inn }}</span>
              </copy-btn>
            </span>
          </span>
          <svg v-if="isSuper" class="ps-chev" :class="{ up: showSel }" viewBox="0 0 24 24"><path d="M6 15l6-6 6 6" /></svg>
        </div>
      </div>
    </div>
    <button class="ps-tog" type="button" aria-label="menu" @click="handleOpen">
      <svg viewBox="0 0 24 24" :class="{ flip: !open }"><path d="M15 6l-6 6 6 6" /></svg>
    </button>
  </aside>
  <div
    class="md:hidden fixed bottom-0 left-0 z-50 w-full h-16 cam border-t"
  >
    <div class="grid h-full max-w-lg grid-cols-4 mx-auto font-medium">
      <router-link
        to="/dashboard"
        class="inline-flex flex-col items-center justify-center px-5 group"
        :class="
          route.path.startsWith('/dashboard')
            ? 'bg-gray-50 dark:bg-gray-700'
            : 'hover:bg-gray-50 dark:hover:bg-gray-700'
        "
      >
        <svg
          class="w-6 h-6 mb-1"
          :class="
            route.path.startsWith('/dashboard')
              ? 'text-blue-600 dark:text-blue'
              : 'text-gray-500 dark:text-gray-400 group-hover:text-blue-600 dark:group-hover:text-blue-500'
          "
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
          ></path>
        </svg>
        <span
          class="text-sm"
          :class="
            route.path.startsWith('/dashboard')
              ? 'text-blue-600 dark:text-blue-500'
              : 'text-gray-500 dark:text-gray-400 group-hover:text-blue-600 dark:group-hover:text-blue-500'
          "
          >{{ $t('navigation.dashboard') }}</span
        >
      </router-link>
      <router-link
        to="/products"
        class="inline-flex flex-col items-center justify-center px-5 group"
        :class="
          route.path.startsWith('/products')
            ? 'bg-gray-50 dark:bg-gray-700'
            : 'hover:bg-gray-50 dark:hover:bg-gray-700'
        "
      >
        <svg
          class="w-6 h-6 mb-1"
          :class="
            route.path.startsWith('/products')
              ? 'text-blue-600 dark:text-blue'
              : 'text-gray-500 dark:text-gray-400 group-hover:text-blue-600 dark:group-hover:text-blue-500'
          "
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          ></path>
        </svg>
        <span
          class="text-sm"
          :class="
            route.path.startsWith('/products')
              ? 'text-blue-600 dark:text-blue-500'
              : 'text-gray-500 dark:text-gray-400 group-hover:text-blue-600 dark:group-hover:text-blue-500'
          "
          >{{ $t('navigation.products') }}</span
        >
      </router-link>
      <router-link
        to="/marking"
        class="inline-flex flex-col items-center justify-center px-5 group"
        :class="
          route.path.startsWith('/marking')
            ? 'bg-gray-50 dark:bg-gray-700'
            : 'hover:bg-gray-50 dark:hover:bg-gray-700'
        "
      >
        <svg
          class="w-6 h-6 mb-1"
          :class="
            route.path.startsWith('/marking')
              ? 'text-blue-600 dark:text-blue'
              : 'text-gray-500 dark:text-gray-400 group-hover:text-blue-600 dark:group-hover:text-blue-500'
          "
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 4v16m8-8H4"
          ></path>
        </svg>
        <span
          class="text-sm"
          :class="
            route.path.startsWith('/marking')
              ? 'text-blue-600 dark:text-blue-500'
              : 'text-gray-500 dark:text-gray-400 group-hover:text-blue-600 dark:group-hover:text-blue-500'
          "
          >{{ $t('navigation.marking') }}</span
        >
      </router-link>
      <router-link
        to="/warehouses"
        class="inline-flex flex-col items-center justify-center px-5 group"
        :class="
          route.path.startsWith('/warehouses')
            ? 'bg-gray-50 dark:bg-gray-700'
            : 'hover:bg-gray-50 dark:hover:bg-gray-700'
        "
      >
        <svg
          class="w-6 h-6 mb-1 -500"
          :class="
            route.path.startsWith('/warehouses')
              ? 'text-blue-600 dark:text-blue'
              : 'text-gray-500 dark:text-gray-400 group-hover:text-blue-600 dark:group-hover:text-blue-500'
          "
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
          ></path>
        </svg>
        <span
          class="text-sm"
          :class="
            route.path.startsWith('/warehouses')
              ? 'text-blue-600 dark:text-blue-500'
              : 'text-gray-500 dark:text-gray-400 group-hover:text-blue-600 dark:group-hover:text-blue-500'
          "
          >{{ $t('navigation.warehouses') }}</span
        >
      </router-link>
    </div>
  </div>
</template>

<script setup lang="ts">
// Premium menu (05.10.2026): zumrut/altin, kayan aktif zemin, kendini cizen ikonlar.
// Linkler, rol filtresi, firma degistirme ve daraltma mantigi ESKISIYLE AYNI.
// Eski hali: Sidebar.old.vue
import { useRoute } from 'vue-router'
import { computed, ref, watch, nextTick, onMounted, onBeforeUnmount } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useSidebar } from '@/composables/useSidebar'
import { useToast } from 'vue-toastification'
import SidebarMarka from '@/components/brand/SidebarMarka.vue'
import ThemeToggle from '@/components/layout/ThemeToggle.vue'
import { getCurrentLocale } from '@/locales'
import apiClient from '@/api/index'

const route = useRoute()
const store = useAuthStore()
const toast = useToast()

const { sidebarOpen, toggleSidebar } = useSidebar()
const open = computed(() => sidebarOpen.value)
const selectedOrganization = ref(
  JSON.parse(localStorage.getItem('asl_current_organization') || '{}').id || 0
)
const currentOrganization = computed(() =>
  JSON.parse(localStorage.getItem('asl_current_organization') || '{}')
)
const user = computed(() => store.user)
const isSuper = computed(() => user.value?.role === 'superadmin')
const accessibleOrganizations = computed(() => {
  return store.accessibleOrganizations.map((org: any) => {
    return {
      name: `${org.name} - ${org.inn}`,
      id: org.id,
    }
  })
})

const sidebarItems = computed(() => {
  const allItems = [
    { name: 'dashboard', path: '/dashboard' },
    { name: 'marking', path: '/marking' },
    { name: 'utilizations', path: '/utilizations' },
    { name: 'aggregations', path: '/aggregations' },
    { name: 'warehouses', path: '/warehouses' },
    { name: 'tasks', path: '/tasks' },
    { name: 'products', path: '/products' },
    { name: 'documents', path: '/documents' },
    { name: 'esf', path: '/esf' },
    { name: 'contractors', path: '/contractors' },
    { name: 'users', path: '/users' },
    { name: 'settings', path: '/settings' },
    { name: 'warehouses-admin', path: `/warehouses/${store.user?.warehouse}` },
  ]
  const userPages = ['aggregations', 'tasks', 'warehouses']
  const inventoryAdminPages = [
    'aggregations',
    'tasks',
    'users',
    'documents',
    'contractors',
    'warehouses-admin',
  ]
  if (store.user?.role === 'user') {
    return allItems.filter((item) => userPages.includes(item.name))
  } else if (store.user?.role === 'inventory_admin') {
    return allItems.filter((item) => inventoryAdminPages.includes(item.name))
  } else if (store.user?.role === 'admin') {
    return allItems.filter((item) => item.name !== 'warehouses-admin')
  } else if (store.user?.role === 'superadmin') {
    return allItems.filter((item) => item.name !== 'warehouses-admin')
  }
  return []
})

// ---- gruplar (sadece gorunum; hangi madde gorunur sidebarItems karar verir)
const GROUPS = [
  { key: 'overview', items: ['dashboard'] },
  { key: 'ops', items: ['marking', 'utilizations', 'aggregations'] },
  { key: 'stock', items: ['warehouses', 'warehouses-admin', 'tasks', 'products'] },
  { key: 'docs', items: ['documents', 'esf', 'contractors'] },
  { key: 'system', items: ['users', 'settings'] },
]
const groups = computed(() =>
  GROUPS.map((g) => ({
    key: g.key,
    items: sidebarItems.value.filter((i) => g.items.includes(i.name)),
  })).filter((g) => g.items.length)
)
const idx = computed(() => {
  const m: Record<string, number> = {}
  let n = 0
  groups.value.forEach((g) => {
    m[g.key] = n++
    g.items.forEach((i) => (m[i.name] = n++))
  })
  return m
})
const SEC: Record<string, Record<string, string>> = {
  ru: { overview: 'Обзор', ops: 'Операции', stock: 'Склад', docs: 'Документы', system: 'Система' },
  en: { overview: 'Overview', ops: 'Operations', stock: 'Warehouse', docs: 'Documents', system: 'System' },
  uz: { overview: 'Umumiy', ops: 'Operatsiyalar', stock: 'Ombor', docs: 'Hujjatlar', system: 'Tizim' },
  'uz-cyrl': { overview: 'Умумий', ops: 'Операциялар', stock: 'Омбор', docs: 'Ҳужжатлар', system: 'Тизим' },
}
const secTitle = (k: string) => (SEC[getCurrentLocale() as string] || SEC.ru)[k] || ''

const isActive = (item: any) => route.path.startsWith(item.path)

// ---- ikonlar (pathLength=1 -> uzerine gelince kendini cizer)
const P = (d: string) => `<path pathLength="1" d="${d}"/>`
const C = (cx: number, cy: number, r: number) => `<circle pathLength="1" cx="${cx}" cy="${cy}" r="${r}"/>`
const ICONS: Record<string, string> = {
  dashboard: P('M3 11l9-7 9 7v9a1 1 0 0 1-1 1h-5v-6h-6v6H4a1 1 0 0 1-1-1z'),
  marking: P('M4 4h6v6H4z') + P('M14 4h6v6h-6z') + P('M4 14h6v6H4z') + P('M14 14h2v2h-2zM18 18h2v2h-2zM14 18h2M18 14h2'),
  utilizations: P('M4 8V5a1 1 0 0 1 1-1h3M16 4h3a1 1 0 0 1 1 1v3M20 16v3a1 1 0 0 1-1 1h-3M8 20H5a1 1 0 0 1-1-1v-3') + P('M4 12h16'),
  aggregations: P('M4 4h7v7H4z') + P('M13 4h7v7h-7z') + P('M4 13h7v7H4z') + P('M13 13h7v7h-7z'),
  warehouses: P('M4 9l8-5 8 5v11H4z') + P('M8 20v-7h8v7'),
  'warehouses-admin': P('M4 9l8-5 8 5v11H4z') + P('M8 20v-7h8v7'),
  tasks: P('M2 6h12v10H2z') + P('M14 10h4l4 4v2h-8') + C(6, 18, 2) + C(18, 18, 2),
  products: P('M4 7h16v13H4z') + P('M4 7l2-3h12l2 3M9 11h6'),
  documents: P('M6 3h9l4 4v14H6z') + P('M14 3v5h5M9 13h7M9 17h5'),
  esf: P('M6 3h9l4 4v14H6z') + P('M14 3v5h5M9 12h6M9 16h6'),
  contractors: P('M3 8h18v12H3z') + P('M8 8V5h8v3M3 13h18'),
  users: C(9, 8, 3) + P('M3 20a6 6 0 0 1 12 0M17 11a3 3 0 1 0 0-6M21 20a6 6 0 0 0-4-5.6'),
  settings: C(12, 12, 3) + P('M12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9l2.1 2.1M17 17l2.1 2.1M4.9 19.1L7 17M17 7l2.1-2.1'),
}

// ---- firma karti (dashboard'daki isim levhasiyla ayni temizlik)
const LEGAL = new Set(['MCHJ', 'XK', 'AJ', 'QK', 'OAJ', 'YATT', 'XT', 'LLC', 'ООО', 'ОАО', 'ЗАО', 'АО', 'ИП', 'МЧЖ', 'ХК', 'АЖ'])
const orgName = computed(() =>
  String(currentOrganization.value?.name || '')
    .replace(/["«»“”„']/g, ' ')
    .split(/\s+/)
    .filter((w) => w && !LEGAL.has(w.toUpperCase()))
    .join(' ')
)
const orgMono = computed(
  () =>
    orgName.value
      .split(' ')
      .filter(Boolean)
      .slice(0, 2)
      .map((w) => w[0])
      .join('')
      .toUpperCase() || 'A'
)
// ---- firma degistirme (14.10.2026): karta tiklayinca dogrudan sik firma listesi acilir
// (eski "isim - INN" Select araligi kaldirildi). Liste body'ye tasinir -> menu kartinin
// overflow'u kesmez; daraltilmis menude de calisir.
const showSel = ref(false)
const orgEl = ref<HTMLElement | null>(null)
const popEl = ref<HTMLElement | null>(null)
const qEl = ref<HTMLInputElement | null>(null)
const listEl = ref<HTMLElement | null>(null)
const orgQ = ref('')
const orgHl = ref(0)
const switching = ref<number | null>(null)
const popPos = ref<Record<string, string>>({})
const curId = computed(() => Number(currentOrganization.value?.id || 0))
const temizAd = (n: any) =>
  String(n || '')
    .replace(/["«»“”„']/g, ' ')
    .split(/\s+/)
    .filter((w) => w && !LEGAL.has(w.toUpperCase()))
    .join(' ')
const orgList = computed(() =>
  (store.accessibleOrganizations || [])
    .map((o: any) => {
      const clean = temizAd(o.name) || String(o.name || '')
      const mono =
        clean
          .split(' ')
          .filter(Boolean)
          .slice(0, 2)
          .map((w: string) => w[0])
          .join('')
          .toUpperCase() || 'A'
      return { id: Number(o.id), inn: String(o.inn || ''), name: String(o.name || ''), clean, mono }
    })
    .sort((a: any, b: any) => a.clean.localeCompare(b.clean, 'ru'))
)
const orgFiltered = computed(() => {
  const s = orgQ.value.trim().toLowerCase()
  if (!s) return orgList.value
  return orgList.value.filter(
    (o: any) => o.clean.toLowerCase().includes(s) || o.name.toLowerCase().includes(s) || o.inn.includes(s)
  )
})
watch(orgQ, () => {
  orgHl.value = 0
  if (listEl.value) listEl.value.scrollTop = 0
})
const placePop = () => {
  const card = orgEl.value
  if (!card) return
  const r = card.getBoundingClientRect()
  const a = (card.closest('.ps') as HTMLElement | null)?.getBoundingClientRect() || r
  const left = Math.round(a.right + 14)
  popPos.value = {
    left: left + 'px',
    bottom: Math.max(12, Math.round(window.innerHeight - r.bottom)) + 'px',
    width: Math.min(372, window.innerWidth - left - 16) + 'px',
    maxHeight: Math.min(560, Math.round(r.bottom - 24)) + 'px',
  }
}
const hlGor = () =>
  nextTick(() => {
    const el = listEl.value?.querySelector('.pso-it.hl') as HTMLElement | null
    el?.scrollIntoView({ block: 'nearest' })
  })
const closePop = (odak = false) => {
  showSel.value = false
  // daraltilmis menu secim icin acik tutulduysa, fare uzerinde degilse geri kapat
  if (peek.value && !orgEl.value?.closest('.ps')?.matches(':hover')) peek.value = false
  if (odak) orgEl.value?.focus()
}
const onOrgClick = () => {
  if (!isSuper.value) return
  if (showSel.value) return closePop()
  orgQ.value = ''
  if (!open.value) {
    clearTimeout(peekTimer)
    peek.value = true
  }
  orgHl.value = Math.max(0, orgFiltered.value.findIndex((o: any) => o.id === curId.value))
  placePop()
  showSel.value = true
  nextTick(() => {
    qEl.value?.focus({ preventScroll: true })
    hlGor()
  })
}
const pickOrg = async (o: any) => {
  if (!o || switching.value) return
  if (o.id === curId.value) return closePop()
  switching.value = o.id
  try {
    await store.switchOrganization(o.id)
    selectedOrganization.value = o.id
    toast.success('Организация успешно переключена')
    window.location.reload()
  } catch (error) {
    console.error(error)
    toast.error(String((error as any)?.message || error))
    switching.value = null
  }
}
const onPopKey = (e: KeyboardEvent) => {
  const n = orgFiltered.value.length
  if (e.key === 'Escape') {
    e.preventDefault()
    closePop(true)
  } else if (e.key === 'ArrowDown' && n) {
    e.preventDefault()
    orgHl.value = (orgHl.value + 1) % n
    hlGor()
  } else if (e.key === 'ArrowUp' && n) {
    e.preventDefault()
    orgHl.value = (orgHl.value - 1 + n) % n
    hlGor()
  } else if (e.key === 'Enter' && n) {
    e.preventDefault()
    pickOrg(orgFiltered.value[orgHl.value])
  }
}
const disTik = (e: MouseEvent) => {
  if (!showSel.value) return
  const t = e.target as Node
  if (popEl.value?.contains(t) || orgEl.value?.contains(t)) return
  closePop()
}
const popYer = () => showSel.value && placePop()
// menu genisligi degisince (daraltma / acilma) liste kartin yanina kayar
const genislik = (e: TransitionEvent) => e.propertyName === 'width' && popYer()
onMounted(() => {
  document.addEventListener('mousedown', disTik)
  window.addEventListener('resize', popYer)
  orgEl.value?.closest('.ps')?.addEventListener('transitionend', genislik as any)
})
onBeforeUnmount(() => {
  document.removeEventListener('mousedown', disTik)
  window.removeEventListener('resize', popYer)
  orgEl.value?.closest('.ps')?.removeEventListener('transitionend', genislik as any)
})

// ---- "35" rozeti: inceleme bekleyen kodlar (gercek veri, dashboard ile ayni endpoint)
const review = ref(0)

// ---- daraltilmis menu: uzerine gelince acilir
const peek = ref(false)
let peekTimer: any = null
const expanded = computed(() => open.value || peek.value)
const onEnter = () => {
  if (open.value) return
  clearTimeout(peekTimer)
  peekTimer = setTimeout(() => (peek.value = true), 120)
}
const onLeave = () => {
  if (showSel.value) return
  clearTimeout(peekTimer)
  peek.value = false
  hov.value.show = false
}

// ---- kayan aktif zemin + fareyi takip eden zemin
const navEl = ref<HTMLElement | null>(null)
const ind = ref({ y: 0, h: 40, show: false })
const hov = ref({ y: 0, h: 40, show: false })
const placeActive = () => {
  const a = navEl.value?.querySelector('.ps-it.on') as HTMLElement | null
  if (!a) {
    ind.value.show = false
    return
  }
  ind.value = { y: a.offsetTop, h: a.offsetHeight, show: true }
}
const flash = () => {
  const ic = navEl.value?.querySelector('.ps-it.on .ps-ic') as HTMLElement | null
  if (!ic) return
  ic.classList.remove('flash')
  void ic.offsetWidth
  ic.classList.add('flash')
}
const onHover = (e: MouseEvent) => {
  const a = (e.target as HTMLElement).closest('.ps-it') as HTMLElement | null
  if (!a) return
  hov.value = { y: a.offsetTop, h: a.offsetHeight, show: true }
}
const onSpot = (e: MouseEvent) => {
  const n = navEl.value
  if (!n) return
  const r = n.getBoundingClientRect()
  n.style.setProperty('--mx', e.clientX - r.left + 'px')
  n.style.setProperty('--my', e.clientY - r.top + n.scrollTop + 'px')
}
watch(
  () => route.path,
  () =>
    nextTick(() => {
      placeActive()
      flash()
    })
)
watch(groups, () => nextTick(placeActive))

const intro = ref(true)
const onResize = () => placeActive()
onMounted(() => {
  if (!document.getElementById('ps-fonts')) {
    const l = document.createElement('link')
    l.id = 'ps-fonts'
    l.rel = 'stylesheet'
    l.href =
      'https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500&family=Cormorant+Garamond:wght@500;600&display=swap'
    document.head.appendChild(l)
  }
  nextTick(placeActive)
  setTimeout(placeActive, 450)
  ;(document as any).fonts?.ready?.then(placeActive)
  setTimeout(() => (intro.value = false), 1400)
  addEventListener('resize', onResize)
  if (['admin', 'superadmin'].includes(user.value?.role)) {
    apiClient
      .get('/dashboard/summary/')
      .then((r: any) => (review.value = Number(r?.data?.buckets?.review) || 0))
      .catch(() => {})
  }
})
onBeforeUnmount(() => {
  removeEventListener('resize', onResize)
  clearTimeout(peekTimer)
})

const handleOpen = () => {
  peek.value = false
  toggleSidebar()
}

const handleOrganizationChange = async () => {
  try {
    await store.switchOrganization(selectedOrganization.value)
    window.location.reload()
    toast.success('Организация успешно переключена')
  } catch (error) {
    console.error(error)
    toast.error(error)
  }
}
</script>

<style>
/* ===== Premium menu — her sey .ps ile baslar, baska sayfaya sizmaz ===== */
.ps {
  --ps-ink: #13203f; --ps-mut: #46557a; --ps-dim: #7483a6; --ps-on: #ffffff;
  --ps-em: #3456c8; --ps-em2: #2a45a6; --ps-ch: #6f8fe8; --ps-ch2: #3456c8;
  --ps-line: rgba(19, 32, 63, 0.08); --ps-tile: rgba(255, 255, 255, 0.45); --ps-hov: rgba(255, 255, 255, 0.4);
  --ps-act: linear-gradient(90deg, rgba(52, 86, 200, 0.12), rgba(52, 86, 200, 0.02) 85%);
  --ps-actline: rgba(52, 86, 200, 0.2); --ps-spot: rgba(52, 86, 200, 0.08);
  --ps-bg: linear-gradient(180deg, rgba(255, 255, 255, 0.42), rgba(255, 255, 255, 0.28));
  --ps-border: rgba(255, 255, 255, 0.75);
  --ps-shadow: 0 10px 34px rgba(40, 60, 120, 0.16);
  position: relative; box-sizing: border-box; flex-shrink: 0; width: 256px; height: 100vh; padding: 10px 0 10px 10px;
  font-family: Manrope, ui-sans-serif, system-ui, sans-serif;
  transition: width 0.35s cubic-bezier(0.22, 1, 0.36, 1);
}
html.dark .ps {
  --ps-ink: #e8f4f4; --ps-mut: #a6c1c3; --ps-dim: #6a898c; --ps-on: #03201c;
  --ps-em: #2dd4bf; --ps-em2: #0d9488; --ps-ch: #5eead4; --ps-ch2: #14b8a6;
  --ps-line: rgba(94, 234, 212, 0.10); --ps-tile: rgba(255, 255, 255, 0.05); --ps-hov: rgba(255, 255, 255, 0.035);
  --ps-act: linear-gradient(90deg, rgba(45, 212, 191, 0.14), rgba(45, 212, 191, 0.02) 85%);
  --ps-actline: rgba(45, 212, 191, 0.18); --ps-spot: rgba(45, 212, 191, 0.09);
  --ps-bg: linear-gradient(180deg, rgba(13, 31, 34, 0.66), rgba(7, 20, 22, 0.74));
  --ps-border: rgba(94, 234, 212, 0.16);
  --ps-shadow: 0 12px 36px rgba(0, 0, 0, 0.5);
}
.ps--mini { width: 64px; }
.ps--mini.ps--peek { width: 256px; }

.ps *, .ps *::before, .ps *::after { box-sizing: border-box; }
.ps-card {
  position: relative; height: 100%; display: flex; flex-direction: column; padding: 12px 10px 10px;
  border-radius: 20px; background: var(--ps-bg); border: 1px solid var(--ps-border);
  box-shadow: var(--ps-shadow), inset 0 1px 0 rgba(255, 255, 255, 0.06); overflow: hidden;
  -webkit-backdrop-filter: blur(14px); backdrop-filter: blur(14px);
  transition: padding 0.35s, box-shadow 0.35s;
}
.ps--mini:not(.ps--peek) .ps-card { padding: 12px 5px 10px; }
.ps--peek .ps-card { box-shadow: 0 30px 80px -22px rgba(0, 0, 0, 0.45), inset 0 1px 0 rgba(255, 255, 255, 0.06); }

/* logo alani: mevcut SidebarMarka, renkleri menuye uyduruldu */
.ps-brand { flex: none; height: 58px; display: flex; align-items: center; padding: 0 6px 10px; margin-bottom: 2px; border-bottom: 1px solid var(--ps-line); overflow: hidden; }
.ps--mini:not(.ps--peek) .ps-brand { padding: 0 0 10px; justify-content: center; }
.ps .sm__logo { height: 40px !important; }
.ps--mini:not(.ps--peek) .sm__logo { height: 30px !important; }
.ps .sm__doku i { background: var(--ps-em) !important; }
.ps .sm__yazi { border-left-color: var(--ps-line) !important; }
.ps .sm__ad span { background-image: linear-gradient(90deg, var(--ps-ink) 0%, var(--ps-ink) 40%, var(--ps-ch) 50%, var(--ps-ink) 60%, var(--ps-ink) 100%) !important; }
.ps .sm__alt, html.dark .ps .sm__alt { color: var(--ps-ch2) !important; letter-spacing: 0.3em !important; font-weight: 600; }
html.dark .ps .sm__alt { color: var(--ps-ch) !important; }

/* maddeler */
.ps-nav { position: relative; flex: 1; min-height: 0; overflow-y: auto; overflow-x: hidden; margin: 0 -10px; padding: 0 10px 6px; transition: margin 0.35s, padding 0.35s; scrollbar-width: none; isolation: isolate; }
.ps-nav::-webkit-scrollbar { display: none; }
.ps--mini:not(.ps--peek) .ps-nav { margin: 0 -5px; padding: 0 5px 6px; }
.ps-nav::before {
  content: ''; position: absolute; inset: 0; z-index: -2; pointer-events: none; opacity: 0; transition: opacity 0.4s;
  background: radial-gradient(160px 120px at var(--mx, 50%) var(--my, -200px), var(--ps-spot), transparent 70%);
}
.ps-nav:hover::before { opacity: 1; }
.ps-ind, .ps-hov { position: absolute; left: 10px; right: 10px; top: 0; border-radius: 12px; pointer-events: none; z-index: -1; opacity: 0; }
.ps-ind { background: var(--ps-act); box-shadow: inset 0 0 0 1px var(--ps-actline); transition: transform 0.55s cubic-bezier(0.22, 1.2, 0.36, 1), height 0.3s, opacity 0.3s; }
.ps-ind::before { content: ''; position: absolute; left: -10px; top: 10px; bottom: 10px; width: 3px; border-radius: 0 3px 3px 0; background: linear-gradient(180deg, var(--ps-ch), var(--ps-ch2)); box-shadow: 0 0 12px var(--ps-ch); transition: left 0.35s; }
.ps--mini:not(.ps--peek) .ps-ind::before { left: -5px; }
.ps--mini:not(.ps--peek) .ps-ind, .ps--mini:not(.ps--peek) .ps-hov { left: 5px; right: 5px; }
.ps-hov { background: var(--ps-hov); transition: transform 0.32s cubic-bezier(0.22, 1, 0.36, 1), height 0.3s, opacity 0.25s; }
.ps-ind.on, .ps-hov.on { opacity: 1; }

.ps-sec { display: flex; align-items: center; gap: 10px; height: 14px; margin: 12px 8px 4px; font: 600 9px/1 Manrope, ui-sans-serif, sans-serif; letter-spacing: 0.28em; text-transform: uppercase; color: var(--ps-ch2); white-space: nowrap; }
html.dark .ps-sec { color: var(--ps-ch); }
.ps-sec::after { content: ''; flex: 1; height: 1px; background: linear-gradient(90deg, var(--ps-actline), transparent); }
.ps-grp:first-of-type .ps-sec { margin-top: 6px; }
.ps-sec span { transition: opacity 0.2s; }
.ps--mini:not(.ps--peek) .ps-sec { margin-left: 4px; margin-right: 4px; }
.ps--mini:not(.ps--peek) .ps-sec span { opacity: 0; width: 0; }

.ps-it {
  position: relative; display: flex; align-items: center; gap: 12px; height: 40px; padding: 0 10px 0 4px;
  color: var(--ps-mut); text-decoration: none; font: 600 13.5px/1 Manrope, ui-sans-serif, sans-serif; letter-spacing: -0.005em;
  white-space: nowrap; border-radius: 12px; transition: color 0.25s, padding 0.35s;
}
.ps--mini:not(.ps--peek) .ps-it { padding: 0 5px; }
.ps-it:focus-visible { outline: 2px solid var(--ps-em); outline-offset: -2px; }
.ps-lb { transition: transform 0.3s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.2s; }
.ps--mini:not(.ps--peek) .ps-lb { opacity: 0; }
.ps-ic {
  position: relative; width: 32px; height: 32px; border-radius: 10px; display: grid; place-items: center; flex: none;
  background: var(--ps-tile); color: var(--ps-mut); overflow: hidden;
  transition: background 0.35s, color 0.35s, box-shadow 0.35s, transform 0.35s cubic-bezier(0.22, 1.3, 0.36, 1);
}
.ps-ic svg { width: 16px; height: 16px; fill: none; stroke: currentColor; stroke-width: 1.75; stroke-linecap: round; stroke-linejoin: round; }
.ps-it:hover { color: var(--ps-ink); }
.ps-it:hover .ps-lb { transform: translateX(2px); }
.ps-it:hover .ps-ic { color: var(--ps-em); transform: translateY(-1px); }
.ps-it:hover:not(.on) .ps-ic svg * { stroke-dasharray: 1; animation: psDraw 0.7s cubic-bezier(0.4, 0, 0.2, 1); }
@keyframes psDraw { from { stroke-dashoffset: 1; } to { stroke-dashoffset: 0; } }
.ps-it.on { color: var(--ps-ink); }
.ps-it.on .ps-ic { background: linear-gradient(145deg, var(--ps-em), var(--ps-em2)); color: var(--ps-on); box-shadow: 0 8px 16px -6px var(--ps-em), inset 0 1px 0 rgba(255, 255, 255, 0.25); }
.ps-ic::after { content: ''; position: absolute; inset: -40%; background: linear-gradient(115deg, transparent 40%, rgba(255, 255, 255, 0.55) 50%, transparent 60%); transform: translateX(-120%); pointer-events: none; }
.ps-ic.flash::after { animation: psSheen 0.9s ease-out; }
@keyframes psSheen { to { transform: translateX(120%); } }

.ps-bd {
  position: relative; margin-left: auto; min-width: 24px; height: 20px; padding: 0 7px; border-radius: 999px; display: grid; place-items: center;
  font: 600 10.5px/1 'JetBrains Mono', ui-monospace, monospace; background: var(--ps-spot); color: var(--ps-ch2);
  box-shadow: inset 0 0 0 1px var(--ps-actline); transition: all 0.25s;
}
html.dark .ps-bd { color: var(--ps-ch); background: var(--ps-spot); }
.ps-bd::after { content: ''; position: absolute; inset: -1px; border-radius: inherit; animation: psHalo 2.8s ease-out infinite; }
@keyframes psHalo { 0% { box-shadow: 0 0 0 0 rgba(52, 86, 200, 0.4); } 70%, 100% { box-shadow: 0 0 0 7px rgba(52, 86, 200, 0); } }
.ps--mini:not(.ps--peek) .ps-bd { position: absolute; top: 6px; left: 31px; min-width: 0; width: 8px; height: 8px; padding: 0; font-size: 0; background: var(--ps-ch); box-shadow: 0 0 0 2px #fff; }
html.dark .ps--mini:not(.ps--peek) .ps-bd { box-shadow: 0 0 0 2px #0d1f22; }

.ps-intro .ps-it, .ps-intro .ps-sec { animation: psRise 0.6s cubic-bezier(0.22, 1, 0.36, 1) both; animation-delay: calc(var(--i, 0) * 35ms); }
@keyframes psRise { from { opacity: 0; transform: translateX(-8px); } }

/* firma karti: dashboard'daki isim levhasinin kucugu (iki temada da koyu zumrut) */
.ps-foot { flex: none; margin-top: 8px; }
.ps-sel { margin-bottom: 8px; }
.ps-org {
  display: grid; grid-template-columns: auto minmax(0, 1fr) auto; align-items: center; gap: 10px; padding: 9px 10px 9px 8px; border-radius: 14px;
  background: var(--ps-org-bg);
  border: 1px solid rgba(var(--ps-org-l), 0.55);
  box-shadow: inset 0 0 0 3px var(--ps-org-in), inset 0 0 0 4px rgba(var(--ps-org-l), 0.22), 0 12px 26px -14px rgba(0, 0, 0, 0.6);
  transition: padding 0.35s, box-shadow 0.25s;
}
.ps-org--btn { cursor: pointer; }
.ps-org--btn:hover { box-shadow: inset 0 0 0 3px var(--ps-org-in), inset 0 0 0 4px rgba(var(--ps-org-l), 0.38), 0 12px 30px -12px rgba(0, 0, 0, 0.7); }
.ps-om { width: 34px; height: 34px; border-radius: 50%; display: grid; place-items: center; flex: none; background: rgba(0, 0, 0, 0.18); border: 1px solid rgba(var(--ps-org-l), 0.6); box-shadow: inset 0 0 0 2px var(--ps-org-in), inset 0 0 0 3px rgba(var(--ps-org-l), 0.22); }
.ps-om i { font: 600 13px/1 'Cormorant Garamond', Georgia, serif; font-style: normal; background: linear-gradient(180deg, var(--ps-org-g1), var(--ps-org-g2)); -webkit-background-clip: text; background-clip: text; color: transparent; }
.ps-ot { min-width: 0; transition: opacity 0.2s; }
.ps-on { display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden; font: 600 13.5px/1.12 'Cormorant Garamond', Georgia, serif; letter-spacing: 0.06em; text-transform: uppercase; color: var(--ps-org-ink); }
.ps-oi { display: flex; align-items: center; gap: 6px; margin-top: 3px; font: 400 10px/1 'JetBrains Mono', ui-monospace, monospace; letter-spacing: 0.1em; color: rgba(var(--ps-org-l), 0.68); }
.ps-oi-l { font-size: 9px; letter-spacing: 0.2em; }
.ps-oi * { color: inherit !important; }
.ps-chev { width: 14px; height: 14px; stroke: rgb(var(--ps-org-l)); fill: none; stroke-width: 1.8; transition: transform 0.25s, opacity 0.2s; }
.ps-chev.up { transform: rotate(180deg); }
.ps--mini:not(.ps--peek) .ps-org { padding: 8px 0; grid-template-columns: 1fr; justify-items: center; }
.ps--mini:not(.ps--peek) .ps-ot, .ps--mini:not(.ps--peek) .ps-chev { display: none; }

/* daraltma dugmesi */
.ps-tog {
  position: absolute; top: 46px; right: 0; transform: translateX(50%); z-index: 5; width: 26px; height: 26px; border-radius: 50%;
  display: grid; place-items: center; cursor: pointer; background: rgba(255, 255, 255, 0.7); border: 1px solid rgba(52, 86, 200, 0.4); color: var(--ps-ch2);
  box-shadow: 0 4px 12px rgba(40, 60, 120, 0.18); transition: transform 0.2s;
}
.ps-tog:hover { transform: translateX(50%) scale(1.1); }
html.dark .ps-tog { background: #0d1f22; border-color: rgba(var(--ps-org-l), 0.38); color: var(--ps-ch); box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5); }
.ps-tog svg { width: 12px; height: 12px; fill: none; stroke: currentColor; stroke-width: 2.2; stroke-linecap: round; stroke-linejoin: round; transition: transform 0.35s; }
.ps-tog svg.flip { transform: rotate(180deg); }

@media (prefers-reduced-motion: reduce) {
  .ps *, .ps *::before, .ps *::after, .ps { animation: none !important; transition: none !important; }
}

/* ===== firma secici (14.10.2026) — menu kartiyla ayni zumrut/altin dil ===== */
.ps-org--btn:focus-visible { outline: 2px solid rgb(var(--ps-org-l)); outline-offset: 2px; }
.pso {
  position: fixed; z-index: 1000; display: flex; flex-direction: column; min-height: 0; overflow: hidden;
  border-radius: 18px; color: var(--ps-org-ink);
  background: var(--ps-org-bg);
  border: 1px solid rgba(var(--ps-org-l), 0.5);
  box-shadow: inset 0 0 0 3px var(--ps-org-in), inset 0 0 0 4px rgba(var(--ps-org-l), 0.16), 0 30px 70px -20px rgba(0, 0, 0, 0.75), 0 0 0 1px rgba(0, 0, 0, 0.25);
  transform-origin: 0 100%; transition: left 0.3s cubic-bezier(0.22, 1, 0.36, 1);
}
.ps-chev { transform: rotate(90deg); }
.ps-chev.up { transform: rotate(-90deg); }
.pso *, .pso *::before, .pso *::after { box-sizing: border-box; }
.pso-hd { flex: none; display: flex; align-items: baseline; justify-content: space-between; padding: 16px 18px 10px; }
.pso-t { font: 600 19px/1 'Cormorant Garamond', Georgia, serif; letter-spacing: 0.04em; color: var(--ps-org-ink); }
.pso-n { font: 500 11px/1 'JetBrains Mono', ui-monospace, monospace; color: rgba(var(--ps-org-l), 0.6); }
.pso-q { flex: none; position: relative; display: block; margin: 0 12px 8px; }
.pso-q svg { position: absolute; left: 12px; top: 50%; width: 15px; height: 15px; margin-top: -7.5px; fill: none; stroke: rgba(var(--ps-org-l), 0.7); stroke-width: 1.8; stroke-linecap: round; pointer-events: none; }
.pso-q input {
  width: 100%; height: 38px; padding: 0 12px 0 36px; border-radius: 11px; outline: none;
  font: 500 13px/1 Manrope, ui-sans-serif, sans-serif; color: var(--ps-org-ink);
  background: rgba(255, 255, 255, 0.05); border: 1px solid rgba(var(--ps-org-l), 0.18);
  transition: border-color 0.2s, background 0.2s, box-shadow 0.2s;
}
.pso-q input::placeholder { color: rgba(var(--ps-org-t), 0.38); }
.pso-q input:focus { border-color: rgba(var(--ps-org-l), 0.55); background: rgba(255, 255, 255, 0.07); box-shadow: 0 0 0 3px rgba(var(--ps-org-l), 0.1); }
.pso-ls { flex: 1; min-height: 0; margin: 0; padding: 2px 8px 10px; list-style: none; overflow-y: auto; scrollbar-width: thin; scrollbar-color: rgba(var(--ps-org-l), 0.25) transparent; }
.pso-it {
  position: relative; display: grid; grid-template-columns: auto minmax(0, 1fr) 18px; align-items: center; gap: 12px;
  padding: 9px 10px; border-radius: 12px; cursor: pointer; transition: background 0.18s;
  animation: psoIn 0.32s cubic-bezier(0.22, 1, 0.36, 1) both; animation-delay: calc(min(var(--i, 0), 12) * 18ms);
}
@keyframes psoIn { from { opacity: 0; transform: translateY(4px); } }
.pso-it.hl { background: rgba(255, 255, 255, 0.055); }
.pso-it.on { background: linear-gradient(90deg, rgba(var(--ps-org-l), 0.14), rgba(var(--ps-org-l), 0.02) 85%); box-shadow: inset 0 0 0 1px rgba(var(--ps-org-l), 0.18); }
.pso-it.on::before { content: ''; position: absolute; left: -8px; top: 12px; bottom: 12px; width: 3px; border-radius: 0 3px 3px 0; background: linear-gradient(180deg, var(--ps-org-g1), var(--ps-org-g2)); box-shadow: 0 0 10px rgba(var(--ps-org-l), 0.55); }
.pso-it.busy { cursor: progress; }
.pso-m { width: 34px; height: 34px; border-radius: 50%; display: grid; place-items: center; background: rgba(0, 0, 0, 0.18); border: 1px solid rgba(var(--ps-org-l), 0.45); box-shadow: inset 0 0 0 2px var(--ps-org-in), inset 0 0 0 3px rgba(var(--ps-org-l), 0.16); transition: border-color 0.2s; }
.pso-it.hl .pso-m, .pso-it.on .pso-m { border-color: rgba(var(--ps-org-l), 0.8); }
.pso-m i { font: 600 13px/1 'Cormorant Garamond', Georgia, serif; font-style: normal; background: linear-gradient(180deg, var(--ps-org-g1), var(--ps-org-g2)); -webkit-background-clip: text; background-clip: text; color: transparent; }
.pso-tx { min-width: 0; display: flex; flex-direction: column; gap: 4px; }
.pso-nm { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font: 600 14.5px/1.1 'Cormorant Garamond', Georgia, serif; letter-spacing: 0.05em; text-transform: uppercase; color: var(--ps-org-ink); }
.pso-it.on .pso-nm { color: var(--ps-org-g1); }
.pso-in { font: 400 10.5px/1 'JetBrains Mono', ui-monospace, monospace; letter-spacing: 0.06em; color: rgba(var(--ps-org-t), 0.5); }
.pso-in b { font-weight: 500; font-size: 9px; letter-spacing: 0.16em; margin-right: 6px; color: rgba(var(--ps-org-l), 0.6); }
.pso-ok { width: 18px; height: 18px; fill: none; stroke: var(--ps-org-g2); stroke-width: 2.2; stroke-linecap: round; stroke-linejoin: round; }
.pso-sp { width: 16px; height: 16px; border-radius: 50%; border: 2px solid rgba(var(--ps-org-l), 0.25); border-top-color: rgb(var(--ps-org-l)); animation: psoSp 0.7s linear infinite; }
@keyframes psoSp { to { transform: rotate(360deg); } }
.pso-empty { padding: 22px 12px; text-align: center; font: 500 12.5px/1.5 Manrope, ui-sans-serif, sans-serif; color: rgba(var(--ps-org-t), 0.5); }
.pso-enter-active { transition: opacity 0.2s ease, transform 0.28s cubic-bezier(0.22, 1.2, 0.36, 1); }
.pso-leave-active { transition: opacity 0.14s ease, transform 0.14s ease; }
.pso-enter-from, .pso-leave-to { opacity: 0; transform: translateX(-8px) scale(0.97); }
@media (prefers-reduced-motion: reduce) {
  .pso, .pso * { animation: none !important; transition: none !important; }
}
</style>
